export class WorkCalendarConstant {
  static WORK_ID = 1;
}
